<template>
    <div>
        <PermissionContent
            v-for="(item, index) in treeData"
            :key="index"
            :view="item"
            :switchStyle="swStyle+'px'"
            :checkStyle="chStyle+'px'"
            :headCheckAll="headCheckAll"
            @handCheck="handCheck"
            @switchChange="switchChange"
        >
            <div v-if="item.views.length>0">
                <PerChild :treeData="item.views" :headCheckAll="item.switched" :switchStyle="swStyle" :checkStyle="chStyle"></PerChild>
            </div>
        </PermissionContent>
    </div>
</template>
<script>
import PermissionContent from "./permission-content.vue";
export default {
  name: "PerChild",
  components: {
    PermissionContent
  },
  props: {
    treeData:{
        type: Array
    },
    switchStyle: {
        type: Number,
        default: 152
    },
    checkStyle: {
        type: Number,
        default: 145
    },
    headCheckAll:{
        type: Boolean
    }
  },
  computed:{
      swStyle(){
          return this.switchStyle - 20;
      },
      chStyle() {
          return this.checkStyle - 22;
      }
  },
  methods:{
    handCheck(o,n) {
    
      o.funcsId = n;
    },
    switchChange(o,n){
      o.switched = n;
    }
  }
};
</script>
